import React from 'react';
import CardUser from '../../shared/components/cards/user.jsx';

const Subsection = (props) => {
  return (
    <>
      <div>
        <h1 className='marketplace-section-title'>{props.title}</h1>
        <div className='marketplace-host-section'> { props.cards.map((card) => <CardUser key={card.key} {...card} />)}</div>
      </div>
    </>
  );
};

export default Subsection;
